import { render, staticRenderFns } from "./ExplanatoryGifModal.vue?vue&type=template&id=18d4807a&scoped=true"
import script from "./ExplanatoryGifModal.vue?vue&type=script&lang=js"
export * from "./ExplanatoryGifModal.vue?vue&type=script&lang=js"
import style0 from "./ExplanatoryGifModal.vue?vue&type=style&index=0&id=18d4807a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4807a",
  null
  
)

export default component.exports